import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { DriverTrackingState } from './driver-tracking.state';

@NgModule({
    declarations: [],
    imports: [
      CommonModule,
      NgxsModule.forFeature([DriverTrackingState])
    ]
  })
export class DriverTrackingStoreModule { }
